import { handleApiError } from "../../../utils/errors";
import { getAuthHeader } from "../../../utils/superagent";
import request from "superagent";

export async function getHostedTimeFacility(userId: string) {
  return await request
    .get(`${global.api}/hosted-time/facility/${userId}`)
    .set(await getAuthHeader())
    .then(({ body }) => body.data)
    .catch((error) => handleApiError(error));
}

export async function putHostedTimeFacility({
  userId,
  name,
  deviceId,
}: {
  userId: string;
  name: string;
  deviceId: number;
}) {
  return await request
    .put(`${global.api}/hosted-time/facility/${userId}`)
    .set(await getAuthHeader())
    .send({ name, deviceId })
    .then(({ body }) => body.message)
    .catch((error) => handleApiError(error));
}
